import React from 'react';
import { LocationIcon, UsageIcon, BatteryIcon, WaterIcon, FilterIcon } from '../common/Icons';

const iconMap = {
  battery: BatteryIcon,
  usage: UsageIcon,
  location: LocationIcon,
  waterChanges: WaterIcon,
  filter: FilterIcon,
};

const variants = {
  primary: 'text-custom-light-blue',
  secondary: 'text-black',
};

const CardIcon = ({ type, variant, className = '' }) => {
  const IconComponent = iconMap[type];

  return <IconComponent className={`text-xl ${variants[variant]} ${className}`} />;
};

export default CardIcon;
